export default "__VITE_ASSET__e42b241d__"